import { RecurlyError } from '@recurly/recurly-js'
import { CheckoutResponseError } from '@pff-consumer/schema'

type PaymentErrors = 'UNKNOWN_APPLE_PAY_ERROR' | 'RECURLY_PAYMENT_ERROR'
type CheckoutErrors = 'GENERIC' | 'INTERNAL_ERROR' | 'ALREADY_SUBSCRIBED' | 'CHECKOUT_PAYMENT_ERROR'

export type CheckoutErrorModalTypes = PaymentErrors | CheckoutErrors

export enum ManualErrorCodes {
  UNKNOWN_APPLE_PAY_ERROR = 'UNKNOWN_APPLE_PAY_ERROR',
}

export const getErrorType = (
  paymentError: RecurlyError | undefined,
  checkoutError: CheckoutResponseError | undefined
): CheckoutErrorModalTypes | undefined => {
  if (paymentError && paymentError.code === 'UNKNOWN_APPLE_PAY_ERROR') {
    return 'UNKNOWN_APPLE_PAY_ERROR'
  }
  if (paymentError) {
    return 'RECURLY_PAYMENT_ERROR'
  }

  // All of these are expected from the CheckoutErrorResponse
  if (checkoutError && 'error' in checkoutError) {
    if (checkoutError.error === 'account_already_subscribed') {
      return 'ALREADY_SUBSCRIBED'
    }
    if (checkoutError.error === 'payment_error') {
      return 'CHECKOUT_PAYMENT_ERROR'
    }
    if (checkoutError.error === 'groot_error' || checkoutError.error === 'internal_error') {
      return 'INTERNAL_ERROR'
    }

    // If we get an unexpected error just use generic
    return 'GENERIC'
  }

  return undefined
}
